//#region src/utils/resolveConversationAvatar.ts
function e(e) {
	let t = e.display, n = t?.name ?? "Conversation";
	return !t || !t.listing_image && !t.counterpart ? {
		primaryImage: t?.avatar ?? null,
		primaryName: n,
		cornerImage: null,
		cornerName: null,
		hasCorner: !1
	} : e.current_user_context === "GUEST" ? {
		primaryImage: t.listing_image ?? null,
		primaryName: t.listing_title ?? n,
		cornerImage: t.counterpart?.avatar ?? null,
		cornerName: t.counterpart?.name ?? n,
		hasCorner: !!t.counterpart
	} : {
		primaryImage: t.counterpart?.avatar ?? t.avatar ?? null,
		primaryName: t.counterpart?.name ?? n,
		cornerImage: t.listing_image ?? null,
		cornerName: t.listing_title ?? null,
		hasCorner: !!t.listing_image
	};
}
//#endregion
export { e as resolveConversationAvatar };
